import { render, staticRenderFns } from "./evacount.vue?vue&type=template&id=b2e384c0&scoped=true"
import script from "./evacount.vue?vue&type=script&lang=js"
export * from "./evacount.vue?vue&type=script&lang=js"
import style0 from "./evacount.vue?vue&type=style&index=0&id=b2e384c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e384c0",
  null
  
)

export default component.exports